<template>
  <SidePanel
    :isVisible="true"
    :rightCommand="true"
    @cancel="onCancel"
    @save="onSave"
    :header="header"
    :save="saveText"
    :cancel="cancelText"
  >
    <div class="sidepanel-body">
      <div class="sidepanel-group">
        <InputText :label="$t('profile.lblName')" v-model="newUser.name" />
      </div>
      <div class="sidepanel-group">
        <InputText :label="$t('profile.lblEmail')" v-model="newUser.email" />
      </div>

      <button
        @click="onChangePassword"
        class="m-1 btn btn btn-sm btn-link profile-btn-link"
      >
        {{ $t('profile.linkChangePassword') }}
      </button>

      <div class="sidepanel-group">
        <label class="k-label">{{ $t('profile.lblLanguage') }}</label>
        <div class="text-size-16">
          <v-select
            :options="optionsLanguages"
            @input="onLocaleSelected"
            v-model="locale"
            :clearable="false"
          ></v-select>
        </div>
      </div>

      <!-- <button class="m-1 btn btn btn-sm btn-link profile-btn-link">
        {{ $t('profile.linkRemoveAccount') }}
      </button> -->
    </div>
  </SidePanel>
</template>

<script>
import SidePanel from '@/components/Rendering/SidePanel.vue';
import InputText from '@/components/UI/InputText.vue';
import { mapState } from 'vuex';
import vSelect from 'vue-select';

export default {
  name: 'EditProfile',

  //  props: ['options'],

  components: {
    SidePanel,
    InputText,
    vSelect,
  },

  data() {
    return {
      newUser: null,
      currentUser: null,
      fake: 'just to show something',
      locale: { code: 'de', label: this.$t('profileDropDown.deLanguageText') },
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.Login.user,
    }),

    optionsLanguages() {
      let options = [
        { code: 'de', label: this.$t('profileDropDown.deLanguageText') },
        { code: 'en', label: this.$t('profileDropDown.enLanguageText') },
      ];
      return options;
    },

    isAnonymousUser() {
      if (this.poll.user.email == 'dummy@kulibri.com') {
        return true;
      }
      return false;
    },

    header() {
      return this.$t('profile.title');
    },

    saveText() {
      return this.$t('profile.dlgSave');
    },

    cancelText() {
      return this.$t('profile.dlgCancel');
    },
  },

  methods: {
    onLocaleSelected(selected) {
      console.log('onSelectedLocate:', selected);
      this.$i18n.locale = this.locale.code;
    },
    onCancel() {
      console.log('Eedit profile cancel');
      this.$i18n.locale = this.currentUser.locale;
      this.$emit('close', null);
    },
    onSave() {
      this.newUser.locale = this.locale.code;
      this.$i18n.locale = this.locale.code;
      this.$store.dispatch('updateUser', this.newUser);
      this.$emit('close');
    },
    onChangePassword() {
      this.$emit('close', 'edit-password');
    },
  },

  created() {
    this.newUser = { ...this.user };
    this.currentUser = this.user;
  },

  mounted() {
    let locale = this.optionsLanguages.find(
      (locale) => locale.code === this.user.locale
    );
    this.locale = locale;
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/style.scss';

.separator {
  box-shadow: 0px 1px 0px #e3e3e3;
  height: 5px;
}

.chnage-pwd {
  color: $primary;
}
.btn-sm {
  padding-left: 0px;
  margin: 0px !important;
}

::v-deep .panel-body {
  overflow: unset;
}




// @media screen and (max-width: 480px) {
//   ::v-deep .vs__selected, .vs__search {
//     font-size: 20px;
//   }
//   ::v-deep .vs__dropdown-menu {
//     font-size: 20px;
//   }
//   textarea {
//     font-size: 20px;
//   }
// }
</style>
